'use strict';

var updateMiniCart = true;
const events = require('../util/events');

module.exports = function () {
    var $body = $('body');
    var $minicart = $('.minicart');
    var $miniCartPopOver = $('.minicart .popover');
    $minicart.on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            $('.minicart .minicart-quantity').text(count.quantityTotal);
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });
            if (count.quantityTotal > 0 && count.quantityTotal < 100) {
                $('.minicart .minicart-quantity').removeClass('d-none');
            } else if (count.quantityTotal > 99) {
                $('.minicart .minicart-quantity').text(' ');
            }
        }
    });

    $minicart.on('click', (event) => {
        events.triggerEventDelayed(event.target, events.TRACKING_MINICART);
    });

    $miniCartPopOver.on('mouseenter touchstart', function () {
        $miniCartPopOver.trigger('minicart:hovered');
    });

    $minicart.on('mouseenter touchstart open:minicart', function () {
        if ($('.search:visible').length === 0) {
            return;
        }
        var url = $minicart.data('action-url');
        var count = parseInt($('.minicart .minicart-quantity').text(), 10);

        if (count !== 0 && $('.minicart .popover.show').length === 0) {
            $minicart.trigger('minicartHover');
            if (!updateMiniCart) {
                $miniCartPopOver.addClass('show');
                $('body').trigger('minicart:updateProductRecommendator');
                return;
            }
            $miniCartPopOver.addClass('show');
            $miniCartPopOver.spinner().start();
            $.get(url, function (data) {
                $miniCartPopOver.empty();
                $miniCartPopOver.append(data);
                import(/* webpackChunkName: "utils-chunk" */ '../utils').then(function (utils) {
                    utils.initalizePaypal();
                });
                updateMiniCart = false;
                $.spinner().stop();
                $('body').trigger('minicart:updateProductRecommendator');
            });
        }

        $('body').trigger('minicart:updateProductRecommendator');
    });
    $body.on('touchstart click', function (e) {
        if ($minicart.has(e.target).length <= 0) {
            $('.minicart .popover').removeClass('show');
        }
    });
    $body.on('change', '.minicart .quantity', function () {
        if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            // location.reload();
        }
    });
    $body.on('product:afterAddToCart', function () {
        updateMiniCart = true;
    });
    $body.on('cart:update', function () {
        updateMiniCart = true;
    });
    $body.on('minicart:updateProductRecommendator', function () {
        if ($('.mini-cart-recommendator-products .product-tile').length >= 1 && $('.minicart-product-recommendator').is(':empty')) {
            if ($('.minicart-product-recommendator').css('display') !== 'none') {
                $miniCartPopOver.addClass('product-recommendator');
            }
            $('.minicart-product-recommendator').html($('.mini-cart-recommendator-products').html());
        }
    });

    $(document).on('click touchstart', '.minicart .close', function () {
        $body.trigger('click');
    });
    var page = document.body.querySelector('.page');
    if (page && page.dataset.action === 'Cart-Show') {
        import(/* webpackChunkName: "utils-chunk" */ '../utils').then(function (utils) {
            utils.initalizePaypal();
        });
        import('../checkout/oneyOSM');
    }
    import(/* webpackChunkName: "cart-chunk" */ '../cart/cart').then(function (module) {
        module.default();
    });
};

(function () {
    var $window = $(window);
    var windowScroll;
    var windowHeight;
    var headerHeight = $('header').innerHeight();
    var bannerHeight = $('.header-banner').innerHeight();
    var menuHeight = $('.header-navigation').innerHeight();
    var miniCartPopOver = $('.minicart .popover.popover-bottom');

    // Setup a timer
    var timeout;

    var adjustPopover = function adjustPopver() {
        windowScroll = $window.scrollTop();
        windowHeight = $window.innerHeight();
        if ($window.width() > 992) {
            if (windowScroll > bannerHeight) {
                miniCartPopOver.attr('style', 'top:' + (menuHeight) + 'px !important; min-height: ' + (windowHeight - menuHeight) + 'px !important; max-height: ' + (windowHeight - menuHeight) + 'px !important');
            } else {
                miniCartPopOver.attr('style', 'top:' + (headerHeight - windowScroll) + 'px !important; min-height: ' + (windowHeight - menuHeight) + 'px !important; max-height: ' + (windowHeight - menuHeight) + 'px !important');
            }
        }
    };

    // Run once on page load
    adjustPopover();

    /**
     * popover listener with timeout
     */
    function popoverListener() {
        // If there's a timer, cancel it
        if (timeout) {
            window.cancelAnimationFrame(timeout);
        }
        // Setup the new requestAnimationFrame()
        timeout = window.requestAnimationFrame(adjustPopover);
    }

    // Listen for scroll events
    window.addEventListener('scroll', popoverListener, false);
    window.addEventListener('resize', popoverListener, false);
}());
